import React from "react";
import { Github, Twitter, Mail, Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-zinc-300 py-12 px-6 mt-20">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12 border-b border-zinc-700 pb-10">
        
        <div>
          <h2 className="text-2xl font-bold text-white mb-2">Mosaic Tech</h2>
          <p className="text-sm leading-relaxed text-zinc-400">
            Building Web3, AI, mobile, and enterprise-grade apps with top-tier global talent.
          </p>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-3">Navigation</h3>
          <ul className="text-sm space-y-2">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/portfolio" className="hover:underline">Portfolio</a></li>
            <li><a href="/team" className="hover:underline">Team</a></li>
            <li><a href="/web3" className="hover:underline">Web3 / Degen</a></li>
            <li><a href="/mint" className="hover:underline">Mosaic Global Mint</a></li>
            <li><a href="/raid" className="hover:underline">Raid Management System</a></li>
            <li><a href="/signin" className="hover:underline">Sign In</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-3">Connect</h3>
          <div className="flex space-x-5">
            <a href="https://github.com/mosaic-tech" target="_blank" rel="noreferrer">
              <Github className="w-5 h-5 hover:text-white" />
            </a>
            <a href="https://twitter.com/mosaicTech_" target="_blank" rel="noreferrer">
              <Twitter className="w-5 h-5 hover:text-white" />
            </a>
            <a href="mailto:info@mosaictechorg.com">
              <Mail className="w-5 h-5 hover:text-white" />
            </a>
            <a href="https://mosaictechorg.com" target="_blank" rel="noreferrer">
              <Globe className="w-5 h-5 hover:text-white" />
            </a>
          </div>
        </div>
      </div>

      <div className="text-center text-sm text-zinc-500 mt-6">
        © {new Date().getFullYear()} Mosaic Global Tech. Built by IconThee_Great
      </div>
    </footer>
  );
};

export default Footer;
